'use client';

import banner1 from '@/assets/images/convention/weddingplannerspro/WeddingPlannersPro.jpg';
import banner1_m from '@/assets/images/convention/weddingplannerspro/WeddingPlannersPro_m.jpg';
import inco1 from '@/assets/images/convention/weddingplannerspro/weddingplannerpro_inco1.svg';
import inco2 from '@/assets/images/convention/weddingplannerspro/weddingplannerpro_inco2.svg';
import inco3 from '@/assets/images/convention/weddingplannerspro/weddingplannerpro_inco3.svg';
import inco4 from '@/assets/images/convention/weddingplannerspro/weddingplannerpro_inco4.svg';
import Button from '@/components/Button';
import Field from '@/components/Field';
import TextInput from '@/components/TextInput';
import useIsMobile from '@/hooks/use-is-mobile';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import Image from 'next/image';
import { useRef } from 'react';
import Slider from 'react-slick';
import { useWeddingPlannersPro } from './useWeddingPlannersPro';
import classes from './weddingPlannersPro.module.css';

export const WeddingPlannersPro = () => {
  const headslider = useRef(null);
  const interests = useRef(null);
  const talonProps = useWeddingPlannersPro({
    headslider,
  });
  const { handleSubmit, response, isLoading, slickIndex, setSlickIndex, activeItem, animate, setAnimate, formApiRef } =
    talonProps;
  const isMobile = useIsMobile();
  const pageTitle = 'WEDDING PLANNERS PRO';

  const howitworks = [
    {
      url: inco1,
      title: 'Refer brides to our website and provide a discount code.',
    },
    {
      url: inco2,
      title: 'Brides select their dresses.',
    },
    {
      url: inco3,
      title: 'Brides / bridesmaids use the code to purchase.',
    },
    {
      url: inco4,
      title: 'You unlock exclusive perks.',
    },
  ];
  const levelofInterest = [
    {
      title: 'VIP Stylist Service For Your Brides',
      level: [1, 1, 1, 1],
    },
    {
      title: 'Free Swatches For Your Brides',
      level: [1, 1, 1, 1],
    },
    {
      title: 'New Costumer Discount For Your Brides',
      level: [1, 1, 1, 1],
    },
    {
      title: 'Comission',
      level: [0, 1, 1, 1],
    },
    {
      title: 'Special Gift From AW Bridal',
      level: [0, 1, 1, 1],
    },
    {
      title: 'Sponsor Dresses',
      level: [0, 0, 1, 1],
    },
    {
      title: 'Free Shipping For Your Brides',
      level: [0, 0, 1, 1],
    },
    {
      title: 'Special Discount For Your Brides',
      level: [0, 0, 0, 1],
    },
    {
      title: 'Cross Promotional Partnership',
      level: [0, 0, 0, 1],
    },
  ];

  const wppSliderProps = {
    dots: false,
    infinite: false,
    showArrows: false,
    slidesToShow: 1.5,
    arrows: false,
    slidesToScroll: 1,
    afterChange: function (index) {
      if (slickIndex !== index) {
        if (index == 2.5 && slickIndex == 3) {
          return false;
        }

        setSlickIndex(index == 2.5 ? 3 : index);
        setAnimate(1);
        setTimeout(() => {
          setAnimate(0);
        }, 800);
      }
    },
  };
  const errorInfo =
    response &&
    (response.message === 'error' ? (
      <span className={classes.errorInfo}>{response.content}</span>
    ) : (
      <span className={classes.succeeInfo}>{response.content}</span>
    ));

  return (
    <div className={classes.weddingplannerspro}>
      <Image
        className={classes.bannerimg}
        src={isMobile ? banner1_m : banner1}
        alt=''
      />
      <h1 className={classes.title}>{pageTitle}</h1>
      <h6 className={classes.subtitle}>
        Calling all wedding planners! Join our program to enjoy special service and unlock new perks for your brides.
      </h6>
      <div className={classes.conent}>
        <h1 className={classes.conenttitle}>BENEFITS PERKS</h1>
        <p className={classes.conentsubtitle}>Refer your brides to AW.Bridal and unlock exclusive perks.</p>
        {isMobile ? (
          <ul className={classes.levelitems}>
            <Slider
              {...wppSliderProps}
              ref={headslider}
            >
              <li
                className={classes.levelitem}
                onClick={() => activeItem(0)}
              >
                <div className={classes.levelcon}>
                  <i className={classes.gradeofpoints} />
                </div>
                <p>Level 1</p>
                <p>Free to Join</p>
              </li>
              <li
                className={classes.levelitem}
                onClick={() => activeItem(1)}
              >
                <div className={classes.levelcon}>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                </div>
                <p>Level 2</p>
                <p>1 Bridal Party</p>
              </li>
              <li
                className={classes.levelitem}
                onClick={() => activeItem(2)}
              >
                <div className={classes.levelcon}>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                </div>
                <p>Level 3</p>
                <p>5 Bridal Parties</p>
              </li>
              <li
                className={classes.levelitem}
                onClick={() => activeItem(3)}
              >
                <div className={classes.levelcon}>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                </div>
                <p>Level 4</p>
                <p>10 & More Bridal Parties</p>
              </li>
            </Slider>
          </ul>
        ) : null}

        <table className={classes.table}>
          {!isMobile ? (
            <thead>
              <tr>
                <td className={classes.theadtitle}>Benefits</td>
                <td>
                  <i className={classes.gradeofpoints} />
                  <p className={classes.theadtitle}>Level 1</p>
                  <p>Free to Join</p>
                </td>
                <td>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <p className={classes.theadtitle}>Level 2</p>
                  <p>1 Bridal Party</p>
                </td>
                <td>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <p className={classes.theadtitle}>Level 3</p>
                  <p>5 Bridal Parties</p>
                </td>
                <td>
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <i className={classes.gradeofpoints} />
                  <p className={classes.theadtitle}>Level 4</p>
                  <p>10 &amp; More Bridal Parties</p>
                </td>
              </tr>
            </thead>
          ) : null}
          <tbody>
            {levelofInterest.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                {item.level.map((arr, i) =>
                  isMobile ? (
                    i == slickIndex ? (
                      arr ? (
                        <td
                          key={i}
                          ref={interests}
                          className={[classes.animated, animate ? classes.slideInRight : null].join(' ')}
                        >
                          {' '}
                          √
                        </td>
                      ) : (
                        <td key={i} />
                      )
                    ) : null
                  ) : arr ? (
                    <td key={i}>√</td>
                  ) : (
                    <td key={i} />
                  ),
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <h1 className={classes.conenttitle}>HOW IT WORKS</h1>
        <div className={classes.howitworks}>
          {howitworks.map((item, index) => (
            <div
              key={index}
              className={classes.work}
            >
              <i className={classes.workno}>{index + 1}</i>
              <Image
                src={item.url}
                className={classes.workicon}
                alt=''
              />
              <p className={classes.worktitle}>{item.title}</p>
            </div>
          ))}
        </div>
        <h1 className={classes.conenttitle}>APPLY</h1>
        <h6 className={classes.conentsubtitle}>Please fill out the form below to apply.</h6>
        <Form
          className={classes.form}
          formApiRef={formApiRef}
          onSubmit={handleSubmit}
          suppressHydrationWarning
        >
          <Field
            id='first-name'
            label={<span className='text-[15px]'>First Name</span>}
            required
          >
            <TextInput
              autoComplete='firstname'
              field='firstname'
              id='firstName'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='last-name'
            label={<span className='text-[15px]'>Last Name</span>}
            required
          >
            <TextInput
              autoComplete='lastname'
              field='lastname'
              id='lastName'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='email'
            label={<span className='text-[15px]'>Email Address</span>}
            required
          >
            <TextInput
              autoComplete='email'
              field='emailaddress'
              id='Email'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='address'
            label={<span className='text-[15px]'>Your Address</span>}
            required
          >
            <TextInput
              autoComplete='address'
              field='address'
              id='Address'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>

          <Field
            id='companyname'
            label={<span className='text-[15px]'>Company Name</span>}
            required
          >
            <TextInput
              autoComplete='companyname'
              field='companyname'
              id='CompanyName'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='companyWebsite'
            label={<span className='text-[15px]'>Company Website</span>}
            required
          >
            <TextInput
              autoComplete='companyWebsite'
              field='companywebsite'
              id='CompanyWebsite'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='yourjobtitle'
            label={<span className='text-[15px]'>Your Job Title</span>}
            required
          >
            <TextInput
              autoComplete='yourjobtitle'
              field='jobtitle'
              id='YourJobTitle'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='instagram'
            label={<span className='text-[15px]'>Your company&apos;s instagram</span>}
            required
          >
            <TextInput
              autoComplete='instagram'
              field='instagram'
              id='Instagram'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='howmanywedding'
            label={<span className='text-[15px]'>How many wedding do you plan a year?</span>}
            className={[classes.howmanywedding, 'isRequired'].join(' ')}
            required
          >
            <TextInput
              autoComplete='howmanywedding'
              field='weddingcount'
              id='Howmanywedding'
              validate={isRequired}
              suppressHydrationWarning
            />
          </Field>
          <Field
            id='suggestion'
            label={<span className='text-[15px]'>Other Suggestion</span>}
            className={classes.suggestion}
          >
            <TextInput
              autoComplete='suggestion'
              field='suggestion'
              id='Suggestion'
              suppressHydrationWarning
            />
          </Field>
          <div>
            <Button
              type='submit'
              disabled={isLoading}
              className={classes.submitButton}
            >
              {isLoading ? 'SUBMITTING...' : 'SUBMIT'}
            </Button>
          </div>
          {errorInfo}
        </Form>
        <div className={classes.qamodule}>
          <h1 className={classes.qamoduletitle}>FREQUENTLY ASKED QUESTIONS</h1>
          <div className={classes.qamodulelist}>
            <div className={classes.qaitem}>
              <p className={classes.q}>How do I join the AW.Bridal wedding planner program?</p>
              <p className={classes.a}>Please fill out the form above to apply.</p>
            </div>
            <div className={classes.qaitem}>
              <p className={classes.q}>What do I get for joining this program?</p>
              <p className={classes.a}>
                You will have access to VIP stylist services, free swatches for your brides, and new customer discounts.
                Once your referred brides or bridesmaid make a purchase, you will unlock new perks and commissions.
              </p>
            </div>
            <div className={classes.qaitem}>
              <p className={classes.q}>How can I refer someone to AW.Bridal?</p>
              <p className={classes.a}>
                When you join our program, we will give you a code to track your referrals. You can refer your brides to
                create a showroom and invite their bridesmaids to make a purchase using the code.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeddingPlannersPro;
